<script>
    import MapInner from "./MapInner.svelte";
    import {getContext} from "svelte";
    import {LeafletSvg} from "vpap/svelte/leaflet";

    export let section;
    export let mapZoom;

    const {projection } = getContext("mapContainer");
</script>

<LeafletSvg
    svgOptions={{clickable:true}}
    innerComponent={MapInner}
    projection={$projection}
    {section}
    {mapZoom}
/>